import actions from './actions'
import getters from './getters'
import mutations from './mutations'
import state, { IGliderState } from './state'
import { Module } from 'vuex/types'
import { IRootState } from '@/store'

const gliderModule: Module<IGliderState, IRootState> = {
  actions,
  getters,
  mutations,
  state
}
export default gliderModule
